"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRoutesBaseDefault = void 0;
var user = { pathname: '/user' };
var workspaces = { pathname: '/workspaces' };
var customClaim = { pathname: '/customClaim' };
var workspaceStat = { pathname: '/workspaceStat' };
var dashboard = { pathname: '/dashboard' };
var confirmEmail = { pathname: '/confirmEmail' };
var acceptInvites = { pathname: '/acceptInvites' };
var stripeSubscription = { pathname: '/stripeSubscription' };
var stripeInvoices = { pathname: '/stripeInvoices' };
var stripeCoupons = { pathname: '/stripeCoupons' };
// Do not give this a type because types are generated from this constant
exports.apiRoutesBaseDefault = {
    user: user,
    workspaces: workspaces,
    customClaim: customClaim,
    workspaceStat: workspaceStat,
    dashboard: dashboard,
    confirmEmail: confirmEmail,
    acceptInvites: acceptInvites,
    stripeSubscription: stripeSubscription,
    stripeInvoices: stripeInvoices,
    stripeCoupons: stripeCoupons,
};
